/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 瞳孔位置
 */
export type VitalPupilPositionEnum =
  (typeof VitalPupilPositionEnum)[keyof typeof VitalPupilPositionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VitalPupilPositionEnum = {
  LEFT: 'LEFT',
  MIDDLE: 'MIDDLE',
  RIGHT: 'RIGHT',
} as const;
